// @flow

export default function(func: Function, wait: number, immediate: boolean) {
  let timeout: ?TimeoutID;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout((timeout: any));
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
